exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper[data-v-68a2437c]{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;height:100vh;background:#ff847b;color:white}.icon[data-v-68a2437c]{font-size:45px;margin:5px}.link[data-v-68a2437c]{text-decoration:underline;cursor:pointer}.row[data-v-68a2437c]{-ms-flex-pack:center;justify-content:center;text-align:center}div[data-v-68a2437c]{text-align:center;line-height:25px}div>*[data-v-68a2437c]{width:100%}\n", ""]);

// exports
